import NBType, { InferType } from '@netbase/nb-type'
import InsightDataSchema from './InsightDataSchema'
import ReturnStatus from '../../enums/ReturnStatus'

const InsightCategorySchema = NBType.object().shape('InsightCategorySchema', {
  extraInfo: NBType.string().nullable(),
  indexCount: NBType.number(),
  insightType: NBType.string(),
  set: NBType.array().of(InsightDataSchema),
  status: NBType.enum(ReturnStatus),
  referenceKey: NBType.string().nullable()
})

export default InsightCategorySchema
export type InsightCategory = InferType<typeof InsightCategorySchema>
// RESERVE BELOW
